import React, { useEffect, useState } from "react";
import axios from "axios";
import "./UserManagement.css";
import Swal from "sweetalert2";

const UserManagement = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
   const res = await axios.get("https://rcfinder.online/api/fetch_users.php");
setUsers(res.data.users);

  };

  // =========================
  // WALLET TRANSFER POPUP
  // =========================
  const transferBalance = async (userId) => {
    const { value: formValues } = await Swal.fire({
      title: "Wallet Transfer",
      html: `
        <input type="number" id="amount" class="swal2-input" placeholder="Enter Amount">

        <select id="type" class="swal2-input">
          <option value="credit">Credit (Add Money)</option>
          <option value="debit">Debit (Cut Money)</option>
        </select>
      `,
      focusConfirm: false,
      confirmButtonText: "Submit",
      showCancelButton: true,
      preConfirm: () => {
        const amount = document.getElementById("amount").value;
        const type = document.getElementById("type").value;

        if (!amount || amount <= 0) {
          Swal.showValidationMessage("Please enter valid amount");
        }

        return { amount, type };
      }
    });

    if (!formValues) return;

    const res = await fetch("https://rcfinder.online/api/transfer_balance.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: userId,
        amount: formValues.amount,
        type: formValues.type
      }),
    });

    const data = await res.json();

    Swal.fire({
      icon: "success",
      title: "Done",
      text: data.message,
    });

    fetchUsers();
  };

  const changePassword = async (userId) => {
    const newPass = prompt("Enter new password:");
    if (!newPass) return;

    await axios.post("https://rcfinder.online/api/change_password.php", {
      user_id: userId,
      password: newPass
    });

    alert("Password Updated");
  };

  const deleteUser = async (userId) => {
    if (!window.confirm("Are you sure?")) return;

    await axios.post("https://rcfinder.online/api/delete_user.php", {
      user_id: userId
    });

    alert("User Deleted");
    fetchUsers();
  };

  const toggleStatus = async (userId, status) => {
    await axios.post("https://rcfinder.online/api/update_status.php", {
      user_id: userId,
      status
    });

    fetchUsers();
  };

  return (
    <div className="user-page">
      <h2>User Management</h2>

      <table className="user-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Mobile</th>
            <th>Wallet</th>
            <th>Actions</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.first_name} {u.last_name}</td>
              <td>{u.mobile}</td>

              {/* if wallet API field wallet_balance hai to yahan change kar dena */}
              <td>₹{u.wallet_balance}</td>

              <td className="actions">
                <button onClick={() => transferBalance(u.id)}>Balance</button>
                <button onClick={() => changePassword(u.id)}>Password</button>
                <button className="delete" onClick={() => deleteUser(u.id)}>Delete</button>
              </td>

              <td>
                <label>
                  <input
                    type="radio"
                    checked={u.status == 1}
                    onChange={() => toggleStatus(u.id, 1)}
                  /> Active
                </label>

                <label style={{ marginLeft: "10px" }}>
                  <input
                    type="radio"
                    checked={u.status == 0}
                    onChange={() => toggleStatus(u.id, 0)}
                  /> Inactive
                </label>
              </td>

            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
};

export default UserManagement;
